// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPersonRegistrationVerifyResponseDto
 */
export interface IPersonRegistrationVerifyResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPersonRegistrationVerifyResponseDto
     */
    employee_id?: number;
}

/**
 * Check if a given object implements the IPersonRegistrationVerifyResponseDto interface.
 */
export function instanceOfIPersonRegistrationVerifyResponseDto(value: object): value is IPersonRegistrationVerifyResponseDto {
    return true;
}

export function IPersonRegistrationVerifyResponseDtoFromJSON(json: any): IPersonRegistrationVerifyResponseDto {
    return IPersonRegistrationVerifyResponseDtoFromJSONTyped(json, false);
}

export function IPersonRegistrationVerifyResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPersonRegistrationVerifyResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
    };
}

export function IPersonRegistrationVerifyResponseDtoToJSON(json: any): IPersonRegistrationVerifyResponseDto {
    return IPersonRegistrationVerifyResponseDtoToJSONTyped(json, false);
}

export function IPersonRegistrationVerifyResponseDtoToJSONTyped(value?: IPersonRegistrationVerifyResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
    };
}

